import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateConcept } from "src/modules/concept/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createConcept } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createConcept(values);
        router.push("/concept");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateConcept)(Create);
